import React, { useEffect, useRef, useState } from "react";
import MainImage from "../Components/MainImage";
import im from "../Media/driver.png";
import SmallBtns from "../Components/SmallBtns";
import {
  Container,
  Stack,
  Typography,
  useMediaQuery,
  Box,
} from "@mui/material";
import logo from "../Media/Mashawiri shortcut.png";
import c1 from "../Media/pngwing.com (40).png";
import c2 from "../Media/pngwing.com - 2023-09-27T112450.576.png";
import c3 from "../Media/pngwing.com - 2023-09-27T112601.609.png";
import c4 from "../Media/motor.png";
import MiniCards from "../Components/MiniCards";
import cc from "../Media/car (1).png";
import cc2 from "../Media/phone.png";
import cc3 from "../Media/card-payment.png";
import OurGoal from "../Components/OurGoal";
import AboutUs from "../Components/AboutUs";
import ServicesCard from "../Components/ServicesCard";
import db from "../DbFile.json";
import Questions from "../Components/Questions";
import { useTranslation } from "react-i18next";

export default function GoAnyWhere({ setTheState }) {
  const matches = useMediaQuery("(min-width:410px)");
  const [el, setEl] = useState(db.first_array);
  const [Qs, setQs] = useState(db.Rdie_Q);
  const { t } = useTranslation();
  useEffect(() => {
    setTheState(false);
  }, []);

  return (
    <div>
      <MainImage
        image={im}
        btxt={"Book Your Ride"}
        txt1={"We Are Here"}
        txt2={"For you"}
      />
      <br />
      <br />
      <Stack sx={{ justifyContent: "center", alignItems: "center" }}>
        <Typography
          sx={{ color: "#1D2877", fontWeight: "bold", fontSize: "30px" }}
        >
          {t("Mashawiri App")}
        </Typography>
      </Stack>
      <br />
      <br />
      <Container>
        <Stack
          direction={matches ? "row" : "column"}
          gap={4}
          sx={{ justifyContent: "center", alignItems: "center" }}
        >
          <SmallBtns txt={"Classic"} scrollTarget="classic" />
          <SmallBtns txt={"VIP"} scrollTarget="vip" />
          <SmallBtns txt={"Van"} scrollTarget="van" />
          <SmallBtns txt={"School Rides"} name={"SchoolRides"} />
        </Stack>
        <br />
        <br />
        <br />
        <br />
        <Stack direction={matches ? "row" : "column"}>
          <Box sx={{ width: "50%" }}>
            <Stack direction="row">
              <img alt="img7985" src={logo} style={{ width: "80px" }} />
              <Typography
                sx={{
                  color: "#1D2877",
                  fontWeight: "bold",
                  fontSize: "30px",
                  marginTop: "2%",
                }}
              >
                {t("Rides")}
              </Typography>
            </Stack>
            <Typography
              sx={{
                color: "gray",
                fontSize: "15px",
                marginTop: "1%",
                marginBottom: "5%",
              }}
            >
              {t("Order a ride with Mashawiri and go faster")}.
            </Typography>
          </Box>
          <br />
          <br />

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
              gap: "30px",
            }}
          >
            <Box
              sx={{
                width: "100px",
                height: "120px",
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: "#C2E1FB",
                borderRadius: "10px",
                padding: "2px",
              }}
            >
              <img alt="img9693" src={c1} style={{ width: "90px" }} />
              <Typography sx={{ color: "#1D2877", fontWeight: "bold" }}>
                {t("Classic")}
              </Typography>
            </Box>

            <Box
              sx={{
                width: "100px",
                height: "120px",
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: "#C2E1FB",
                borderRadius: "10px",
                padding: "2px",
              }}
            >
              <a href="#" style={{ backgroundColor: "#C2E1FB" }}>
                <img alt="img963258" src={c2} style={{ width: "90px" }} />
                <Typography sx={{ color: "#1D2877", fontWeight: "bold" }}>
                  {t("VIP")}
                </Typography>
              </a>
            </Box>

            <Box
              sx={{
                width: "100px",
                height: "120px",
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: "#C2E1FB",
                borderRadius: "10px",
                padding: "2px",
              }}
            >
              <a href="#" style={{ backgroundColor: "#C2E1FB" }}>
                <img alt="img85698" src={c3} style={{ width: "90px" }} />

                <Typography sx={{ color: "#1D2877", fontWeight: "bold" }}>
                  {t("Van")}
                </Typography>
              </a>
            </Box>
          </div>
        </Stack>
        <br />
        <br />
        <br />

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: "60px",
          }}
        >
          <MiniCards
            imgg={cc}
            txt={"Choose your ride"}
            txt2={
              "Select from a wide range of options and get your ride within minutes, or schedule one for later."
            }
          />
          <MiniCards
            imgg={cc2}
            txt={"Track your ride"}
            txt2={
              "enhances safety and security by providing users with visibility into their driver`s location and route"
            }
          />
          <MiniCards
            imgg={cc3}
            txt={"Pay securely"}
            txt2={
              "ensuring safe and protected payment transactions, protect sensitive information"
            }
          />
        </div>
      </Container>
      <div id="classic">
        <OurGoal
          caption={"CLASSIC"}
          im={c1}
          btn={"Book your ride"}
          bgcolor={"#E3EFF9"}
          txt={
            "Use our rides for everyday trips and commutes. We’ll get you where you need to go so you don’t have to."
          }
        />
      </div>
      <div id="vip">
        <AboutUs
          txt={
            "Enjoy the ultimate convenience in a ride, with just a few clicks. Travel in comfort and in style."
          }
          caption={"VIP"}
          pic={c2}
          bgcolor={"#C2E1FB"}
          btn={"Book your ride"}
          id="vip"
        />
      </div>
      <div id="van">
        <OurGoal
          caption={"VAN"}
          im={c3}
          id="van"
          bgcolor={"#E3EFF9"}
          btn={"Book your ride"}
          txt={
            "Are you traveling in a big group? Take our Premium Max rides we can take up to eleven people to their next destination."
          }
        />
      </div>

      <Box
        sx={{
          marginTop: "5%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Stack>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "40px",
              color: "#1D2877",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {t("Explore more with Mashawiri")}
          </Typography>
          {el && <ServicesCard el={el.filter((el) => el.id > 1)} />}
        </Stack>
      </Box>

      <Questions questions={Qs} />
    </div>
  );
}
